import { Injectable } from '@angular/core';
import {
  Analytics,
  initializeAnalytics,
  logEvent,
} from '@angular/fire/analytics';
import { FirebaseApp } from '@angular/fire/app';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs';

import { IAnalyticsService } from '../models/IAnalyticsService';

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService implements IAnalyticsService {
  private isEnabled = true;

  constructor(
    private app: FirebaseApp,
    private analytics: Analytics,
    private router: Router
  ) {
    initializeAnalytics(this.app);
  }

  setIsEnabled(isEnabled: boolean) {
    this.isEnabled = isEnabled;
  }

  setCurrentScreen() {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map((event) => event as NavigationEnd),
        filter(() => this.isEnabled === true)
      )
      .subscribe((event: NavigationEnd) => {
        logEvent(this.analytics, 'screen_view' as any, { value: event.url });
      });
  }

  trackEvent(eventName: string, value: any) {
    this.router.events
      .pipe(filter(() => this.isEnabled === true))
      .subscribe(() => logEvent(this.analytics, eventName, { value }));
  }
}
